import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherAqi from "./WeatherAqi";
import WeatherUvi from "./WeatherUvi";
import WeatherPrecipitation from "./WeatherPrecipitation";

export default function WeatherInfo(props) {
  const currentTemperature = Math.round(props.data.temperature);
  return (
    <div className="WeatherInfos">
      <h1>{props.data.city}</h1>
      <ul>
        <li>
          <FormattedDate date={props.data.date} />
        </li>
        <li className="text-capitalize">{props.data.description}</li>
      </ul>
      <div className="row pt-4">
        <div className="col-6">
          <div className="d-flex temperature">
            <img src={props.data.iconUrl} alt={props.data.description} />
            {currentTemperature}{" "}
            <span className="unit">{props.currentUnit}</span>
          </div>
        </div>

        <div className="col-6 ">
          <ul className="descriptionweather">
            <li>
              Precipitation:{" "}
              <WeatherPrecipitation coordinates={props.data.coordinates} /> %
            </li>
            <li>Humidity: {Math.round(props.data.humidity)} %</li>
            <li>Wind: {Math.round(props.data.wind)} km/h</li>
            <li>
              Air Quality: <WeatherAqi coordinates={props.data.coordinates} />
            </li>
            <li>
              UV Index: <WeatherUvi coordinates={props.data.coordinates} /> /15
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
